/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { forwardRef } from 'react';

import { cssMap, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import {
	TAB_GAP,
	UNSAFE_HORIZONTAL_NAVIGATION_COLOR_BORDER_VAR,
} from '@atlassian/navigation-kit-common';

const ResponsiveNav = forwardRef<
	HTMLElement,
	React.PropsWithChildren<{ id?: string; label: string }>
>(({ children, label, id }, ref) => (
	<nav aria-label={label} css={[styles.root]} ref={ref} id={id}>
		{children}
	</nav>
));

const styles = cssMap({
	root: {
		display: 'flex',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		gap: `${TAB_GAP}px`,
		position: 'relative',
		minWidth: 0,
		paddingLeft: token('space.200'),
		paddingRight: token('space.200'),
		// Underline separating tabs from page content
		'&::before': {
			content: "''",
			position: 'absolute',
			bottom: 0,
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
			background: `var(${UNSAFE_HORIZONTAL_NAVIGATION_COLOR_BORDER_VAR}, ${token('color.border')})`,
			height: '1px',
			left: 0,
			right: 0,
		},
	},
});

export default ResponsiveNav;
